/**
 * Created by sy on 2018/9/14.
 */
const ARTICLE = {
  DETAILS: "DETAILS",
};

const INDEX = {
  BANNERLIST: "BANNERLIST",
};

const SEARCH = {
  SEARCHwORD: "SEARCHwORD",
  // SEARCHNAV:'SEARCHNAV',
};
export { ARTICLE, INDEX, SEARCH };
